import React, { useEffect } from 'react';
import { useTenant } from '../hooks';
import { Loading } from '../views/components/shared/loaders';

interface TenantProviderProps {
  children: React.ReactNode;
}

const setFavicon = (href: string) => {
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
};

const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
  const { isInitialized, error, theme } = useTenant();

  useEffect(() => {
    const faviconUrl = theme?.assets?.faviconUrl;
    if (faviconUrl) {
      setFavicon(faviconUrl);
    }
  }, [theme]);

  if (!isInitialized) {
    return <Loading />;
  }

  if (error) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-text mb-2">
            Can't load workspace
          </h1>
          <p className="text-text-placeholder">
            No tenant found for domain: {globalThis.location.hostname}
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default TenantProvider;
